var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenalty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "24px",
    viewBox: "0 0 28 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / play entry / penalty") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,5 C5.90124894,5 7.12534051,5.82808833 7.68175638,7.03909267 C7.86673142,7.02117451 8.05500443,7.00935336 8.24483973,7.0037566 L8.5,7 L17,7 L17,10 L18,10 L20.9995527,7 L28,7 L28,13 L16.7614194,17.5080717 L16.743067,17.5823685 C15.814386,21.2700881 12.4759956,24 8.5,24 C3.80557963,24 0,20.1944204 0,15.5 C0,13.6301922 0.603741144,11.9013958 1.62691615,10.4979179 C1.22613546,9.92443309 1,9.23121699 1,8.5 C1,6.56700338 2.56700338,5 4.5,5 Z M16,7.999 L8.5,8 C4.43908272,8 1.13198248,11.2274744 1.00385357,15.2572689 L1,15.5 C1,19.6421356 4.35786438,23 8.5,23 C11.8697386,23 14.7917332,20.7586196 15.7069285,17.5841692 L15.7900581,17.2704645 L15.9121656,16.7712772 L27,12.323 L27,7.999 L21.414,7.999 L18.4142572,11 L16,11 L16,7.999 Z M8.5,11 C10.9852814,11 13,13.0147186 13,15.5 C13,17.9852814 10.9852814,20 8.5,20 C6.01471863,20 4,17.9852814 4,15.5 C4,13.0147186 6.01471863,11 8.5,11 Z M8.5,12 C6.56700338,12 5,13.5670034 5,15.5 C5,17.4329966 6.56700338,19 8.5,19 C10.4329966,19 12,17.4329966 12,15.5 C12,13.5670034 10.4329966,12 8.5,12 Z M4.5,6 C3.11928813,6 2,7.11928813 2,8.5 C2,8.92413321 2.10627548,9.33006846 2.29938165,9.68760721 C3.44373685,8.46569093 4.94542545,7.58293347 6.63753485,7.2046753 C6.19894435,6.47915326 5.40058318,6 4.5,6 Z M24.2375769,1.07490769 L25.0567289,1.64848413 L22.7624231,4.92509231 L21.9432711,4.35151587 L24.2375769,1.07490769 Z M12.7624231,1.07490769 L15.0567289,4.35151587 L14.2375769,4.92509231 L11.9432711,1.64848413 L12.7624231,1.07490769 Z M19,0 L19,4 L18,4 L18,0 L19,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-/-play-entry-/-penalty",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Path",
    fill: "#91ACCA",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenalty);
export default __webpack_public_path__ + "static/media/penalty.ac750727fd05d111c46feefcdd0327d3.svg";
export { ForwardRef as ReactComponent };